












import { Component, Vue, Prop } from "vue-property-decorator";
import { BreadcrumbItem } from "@/components/apps/NavigationBreadcrumb.vue";
import LoadingStore from "@/store/modules/loading";
import { getModule } from "vuex-module-decorators";
const loadingStore = getModule(LoadingStore);

@Component({
  components: {}
})
export default class BreadCrumb extends Vue {
  @Prop()
  breadcrumbItems!: BreadcrumbItem[];

  @Prop()
  height = "56px";

  get loading() {
    return loadingStore.isLoading;
  }
}
